export default __webpack_public_path__ + "static/media/live_map.15272e63.svg";